import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewDidEnter, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react'
import { UseHeader, MktEmpty, PageLoading } from '@cps'
import { MemberApi } from '@api/index'
import { memberMobx } from '@mobxStore'
import { storeMobx } from 'restaurant'
import { each } from '@dt/fe-utils/dist/lodash'
import { modalLayer } from '@utils'
import { useGiftCardDecorationInit, useGiftCardPageTitle } from '@common/hooks'
import GiftRecordItem from '../components/GiftRecordItem'
import GiftRecordDetail from '../components/GiftRecordDetail'
import './index.scss'

import noGiftCardImg from '@img/no-giftcard.png'

interface IProps extends IPage, RouteComponentProps {
}

const pageSize: number = 12

const Card: FC<IProps> = ({ match, history }) => {
  // Component State
  const [page, setPage] = useState<number>(1)
  const [logs, setLogs] = useState<any[]>([])
  const [canget, setCanget] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(true)
  // Data Method
  const getData = (pageNum: number, data: any[]) => {
    const allStoerId: any[] = []
    each(storeMobx.storeList, (item: any) => {
      allStoerId.push(item.storeId)
    })
    const para: any = {
      brandId: storeMobx.brand.brandId,
      memberId: memberMobx.memberInfo.memberId,
      page: pageNum,
      limit: pageSize,
    }
    setPage(pageNum)
    MemberApi.getGiveLogs(para).then((res: any) => {
      if (!res.error) {
        setLogs(data.concat(res.items))
        if (pageNum >= res.meta.totalPages) {
          setCanget(false)
        } else {
          setCanget(true)
        }
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const openDetail = (info: any) => {
    modalLayer(GiftRecordDetail, { recordInfo: info }, 'giftRecordDetail').then(() => {
      getData(1, [])
    }).catch(() => { })
  }

  const onScrollEnd = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        getData(page + 1, logs)
        ev.target.complete()
      }, 500)
    }
  }

  useGiftCardDecorationInit()
  useGiftCardPageTitle()
  useIonViewDidEnter(() => {
    getData(1, [])
  })
  return (
    <IonPage className='gift-record-page'>
      <UseHeader onBack={() => history.goBack()} title={i18n.t('mkt.giftCard.transferRecord')}></UseHeader>
      <IonContent className='page-content'>
        {loading && <PageLoading />}
        {!loading && logs.length === 0 && <MktEmpty img={noGiftCardImg} />}
        {logs.length >= 0 &&
          <div className='log-body'>
            {
              logs.map((item: any, index: number) => {
                return (
                  <div data-cypid='mmgToGCardRecordDetail' className='log-block' key={index} onClick={() => openDetail(item)}>
                    <GiftRecordItem recordInfo={item} key={index}></GiftRecordItem>
                  </div>
                )
              })
            }
          </div>}
        {
          canget &&
            <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => onScrollEnd(ev)}>
              <IonInfiniteScrollContent
                loadingSpinner='bubbles'
                loadingText={i18n.t('order.loadmore')}
              >
              </IonInfiniteScrollContent>
            </IonInfiniteScroll>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(Card)
